'use strict';

export default function getInfrastructureItems () {
  return [
    {
      id: 'gym',
      name: 'фитнес'
    },
    {
      id: 'school',
      name: 'школы'
    },
    {
      id: 'store',
      name: 'детские сады'
    },
    {
      id: 'beauty-salon',
      name: 'парикмахерские'
    },
    {
      id: 'plumber',
      name: 'ЖЭУ'
    },
    {
      id: 'convenience-store',
      name: 'продукты'
    },
    {
      id: 'post-office',
      name: 'почта'
    },
    {
      id: 'parking',
      name: 'парковки'
    },
    {
      id: 'grocery-or-supermarket',
      name: 'супермаркеты'
    },
    {
      id: 'shopping-mall',
      name: 'торговые центры'
    },
    {
      id: 'health',
      name: 'аптеки'
    },
    {
      id: 'bank',
      name: 'банки'
    }
  ];
};

export function sortByName (l, r) {
  const ln = l.name.toLowerCase();
  const rn = r.name.toLowerCase();

  if (ln < rn) {
    return -1;
  } else if (ln > rn) {
    return 1;
  }

  return 0;
}



// WEBPACK FOOTER //
// ./src/utils/infrastructure.js